import {Box, HStack} from '@chakra-ui/react';
import {NavButton} from '../NavButton';
import {HomeIcon} from '../../svg/HomeIcon';
import {useTranslation} from 'react-i18next';
import {CatalogueIcon} from '../../svg/CatalogueIcon';
import NiceModal from '@ebay/nice-modal-react';
import {CatalogueModale} from '@/domains/article/NomenclatureModale/CatalogueModale';
import {MenuClientMobileModale} from '@/domains/client/menu/MenuClientMobileModale';
import {isBottomNavActive, routes, useRemoveAllModal} from 'ff-common';
import {useClientRoute} from '@/hooks/auth/useClientRoute';
import {ListIcon} from '../../svg/ListIcon';
import {UserIcon} from '../../svg/UserIcon';
import {useLocation} from 'react-router-dom';

export const bottomNavHeight = '4.5rem';

export const BottomNav: React.FC = () => {
  const {t} = useTranslation();
  const location = useLocation();
  const {buildClientRoute} = useClientRoute();
  const closeModales = useRemoveAllModal();

  //TODO(Nathan) Catalogue & Profil : Toggle les modales lorsqu'elles sont déjà ouvertes

  const dansLePanier = location.pathname.startsWith(
    routes.client.panier_default.path,
  );

  const isAccueilActive = isBottomNavActive(location.pathname, 'accueil');
  const isCatalogueActive = isBottomNavActive(location.pathname, 'catalogue');
  const isMesProduitsActive = isBottomNavActive(
    location.pathname,
    'mes-produits',
  );
  const isProfilActive = isBottomNavActive(location.pathname, 'profil');

  return (
    !dansLePanier && (
      <HStack
        zIndex='popover'
        display={{base: 'flex', md: 'none'}}
        position='fixed'
        bottom='0'
        justify='space-between'
        alignContent='stretch'
        bg='white'
        textColor='gray.dark'
        w='100vw'
        h={bottomNavHeight}
        px={{base: '0', md: '12'}}
        gap={{base: '0', md: '1'}}
        boxShadow='base'
      >
        {/* Accueil */}
        <NavButton
          ButtonIcon={HomeIcon}
          label={t('global.accueil')}
          onClick={closeModales}
          to={buildClientRoute(routes.client.accueil)}
          color={isAccueilActive ? 'blue.main' : 'gray.dark'}
        />
        {/* Catalogue */}
        <NavButton
          ButtonIcon={CatalogueIcon}
          label={t('global.catalogue')}
          showAs={Box}
          onClick={() => {
            closeModales();
            NiceModal.show(CatalogueModale);
          }}
          color={isCatalogueActive ? 'blue.main' : 'gray.dark'}
        />
        {/* Mes produits */}
        <NavButton
          ButtonIcon={ListIcon}
          label={t('liste.mes_produits')}
          onClick={() => {
            closeModales();
          }}
          to={buildClientRoute(routes.client.cadencier)}
          color={isMesProduitsActive ? 'blue.main' : 'gray.dark'}
        />
        {/* Profil */}
        <NavButton
          ButtonIcon={UserIcon}
          label={t('global.profil')}
          showAs={Box}
          onClick={() => {
            closeModales();
            NiceModal.show(MenuClientMobileModale);
          }}
          color={isProfilActive ? 'blue.main' : 'gray.dark'}
        />
      </HStack>
    )
  );
};
